module.exports = __webpack_public_path__ + "img/ruffle length.cb329334.png";